import moment from 'moment';
import { Client } from '../libs/types/src';
import Papa from 'papaparse';

export const formatTimeAgo = (utcDateString: string): string => {
    if (!utcDateString) return "";
    const date = moment.utc(utcDateString).local(); // Parse as UTC, convert to local
    if (!date.isValid()) return "";
    const now = moment();
    const diffInWeeks = now.diff(date, "weeks");
    if (diffInWeeks < 4) {
      return date.fromNow();
    } else {
      return date.format("MMM D, YYYY");
    }
  };

export function isPaidClient(client: Client): boolean {
  return (client.active && !client.trial_active);
}

export function csvToJson(csv: string): any[] {
  const result = Papa.parse(csv, { header: true, skipEmptyLines: true });
  return result.data;
}